import React from 'react'
import AgentApiContent from '../components/AgentApi/AgentApiContent'


const AgentApi = (props) => {

  return (
    <>
        <AgentApiContent following = {props.following === true ? true : false}/>
    </>
  )
}

export default AgentApi